/**
 * Remove Website Builder implementation payloads from assistant chat copy.
 *
 * Generated HTML/CSS belongs in the artifact preview/code panel. During streaming the closing
 * fence often has not arrived yet, so a conventional closed-fence regex briefly exposes the code
 * in chat. This filter also removes an unfinished artifact fence and its partial opening marker.
 */
export function stripArtifactCodeFences(content: string): string {
  let visible = content
    // Complete artifact fences.
    .replace(/```(?:html|css)[^\n]*\n[\s\S]*?```/gi, '')
    // An artifact fence whose closing marker has not streamed yet.
    .replace(/```(?:html|css)[^\n]*(?:\n[\s\S]*)?$/gi, '')

  // The opening marker itself may be split across chunks: `, ``, ```, ```h, ... . Only suppress
  // it when it starts a new fence; an ordinary closing ``` for a JSON/Markdown block must remain.
  const partialOpening = visible.match(/(^|\n)[ \t]*`{1,3}(?:h(?:t(?:m(?:l)?)?)?|c(?:s(?:s)?)?)?$/i)
  if (partialOpening?.index !== undefined) {
    const preceding = visible.slice(0, partialOpening.index)
    const completeFenceMarkersBefore = preceding.match(/```/g)?.length ?? 0
    if (completeFenceMarkersBefore % 2 === 0) {
      visible = `${preceding}${partialOpening[1]}`
    }
  }

  visible = visible.replace(/\n{3,}/g, '\n\n').trim()
  return visible
}
